module.exports = __webpack_public_path__ + "img/australia-diseases-of-the-nervous-system-female.ad91c246.png";